import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Col, Card, CustomInput } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { Field, useField } from 'react-final-form';

import FormField, { FormError } from 'components/Form/FormField';
import { required, composeValidators, isDateValue } from 'utils/formValidators';
import { SingleDatePicker } from 'react-dates';
import SingleDatePickerWrapper from '../../SoonoSocial/SingleDatePickerWrapper';

import 'assets/scss/components/reactDatePicker.css';

const RewardConfiguration = ({ values, form }) => {
  const defaultCustomTerms = useField('defaultCustomTerms', form);
  const customTerms = useField('customTerms', form);
  const customizeTerms = useField('customizeTerms', form);

  return (
    <div className="px-3">
      <FormField
        label="Reward"
        name="reward"
        placeholder="Ex: 10% off your next purchase"
        containerClassName="form-group"
        inputClassName="form-control"
        validate={required}
      />
      <Field name="limit_voucher_per_customer" type="checkbox">
        {({ input }) => {
          return (
            <div>
              <div className="custom-survey-field mt-2" fluid>
                <CustomInput id={input.name} {...input} />
                <label htmlFor={input.name} className="cursor-pointer">
                  Limit one (1) voucher per customer
                </label>
              </div>
            </div>
          );
        }}
      </Field>
      <hr />
      {/* <FormField
        label="Voucher Expires"
        name="expiryDate"
        placeholder="mm/dd/yyyy"
        containerClassName="row align-items-center"
        labelClassName="col-md-2"
        inputClassName="form-control col-md-2 voucher-expiry-date"
        validate={composeValidators(required, isDateValue)}
      /> */}
      <Field
        name="expiryDate"
        validate={required}
        component={({ input }) => {
          return (
            <React.Fragment>
              <label className="mr-2">Voucher Expires</label>
              <SingleDatePickerWrapper
                {...input}
                small
                date={input.value}
                onDateChange={input.onChange}
              />
              <FormError name={input.name} />
            </React.Fragment>
          );
        }}
      />
      <hr />
      <div className="custom-terms-container">
        {!values.customizeTerms ? (
          <React.Fragment>
            <label>Reward Terms and Conditions</label>
            <Card className="border-0 reward p-2 mb-2 shadow-2">
              <p>
                {values.limit_voucher_per_customer
                  ? `Limit one (1) voucher per customer. `
                  : ''}
                {`Voucher expires on ${values.expiryDate.calendar()}. `}
                {values.defaultCustomTerms}
              </p>
            </Card>
          </React.Fragment>
        ) : (
          <Field name="customTerms" validate={required}>
            {({ input, meta }) => (
              <FormGroup>
                <label htmlFor={input.name}>Reward Terms and Conditions</label>
                <textarea
                  className="form-control"
                  id={input.name}
                  rows={2}
                  {...input}
                />
                <FormError name={input.name} />
                <Col className="text-right">
                  <span
                    role="none"
                    className="circular-icon icon-check mt-2"
                    onClick={() => {
                      if (customTerms.meta.error) return;
                      defaultCustomTerms.input.onChange(
                        customTerms.input.value
                      );
                      customizeTerms.input.onChange(false);
                    }}
                  >
                    <FontAwesomeIcon icon="check" />
                  </span>
                  <span
                    role="none"
                    className="circular-icon icon-cross mt-2"
                    onClick={() => {
                      customTerms.input.onChange(
                        defaultCustomTerms.input.value
                      );
                      customizeTerms.input.onChange(false);
                    }}
                  >
                    <FontAwesomeIcon icon="times" />
                  </span>
                </Col>
              </FormGroup>
            )}
          </Field>
        )}
        {!values.customizeTerms && (
          <Field
            name="customizeTerms"
            type="checkbox"
            render={({ input }) => {
              return (
                <div className="custom-survey-edit" fluid>
                  <span
                    role="presentation"
                    className="cursor-pointer"
                    onClick={() => input.onChange(!values[input.name])}
                  >
                    <FontAwesomeIcon icon="pencil-alt" />
                  </span>
                </div>
              );
            }}
          />
        )}
      </div>
    </div>
  );
};

RewardConfiguration.propTypes = {
  values: PropTypes.shape({
    customizeTerms: PropTypes.bool,
  }).isRequired,
  form: PropTypes.node.isRequired,
};

export default RewardConfiguration;



// WEBPACK FOOTER //
// ./src/components/customSurvey/FormFields/rewardConfiguration.js